import { render, staticRenderFns } from "./FaenaBanoVacuna.vue?vue&type=template&id=692d0d3c"
import script from "./FaenaBanoVacuna.vue?vue&type=script&lang=js"
export * from "./FaenaBanoVacuna.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports